import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CancelAsync } from './../../app/models/cancelAsync';

import { ModalIframeComponent, ModalMarketingComponent } from '@app/modals';
import { ModalController } from '@ionic/angular';

import {
  AppInitService,
  CerfaService,
  NavigationService,
  OffersService,
  PageLoaderService,
  PaymentsService,
  StatsService,
  StudentService,
} from '@app/services';
import * as moment from 'moment-timezone';
import { Student, StudentPurshasesDetails } from '@app/app.models';

import { UtilsService } from '@commons/services';

import { EasyDebugDecorator } from '../../app/decorators/easy-debug.decorator';

@EasyDebugDecorator
@Component({
  selector: 'achats-page',
  templateUrl: 'achats.page.html',
  styleUrls: ['achats.page.scss'],
})
export class AchatsPage extends CancelAsync {
  pageTitle = 'Mes achats';
  activeLink = 'profil';

  iconPath = './uikit-assets/icons/orion-svg-sprite.svg#';

  blocHeaderTitle = 'Mes achats';

  student: Student;
  creditStocks = [];
  userLifeCycle: any;

  longLoading = false;
  pageStart = Date.now();
  checkPageLoadingTimeInterval: any;

  studentPurshases: StudentPurshasesDetails;
  payments = [];
  gifts = [];
  coupons = [];
  cpfSubscriptions = [];
  paymentsGiftsCoupons: any = [];
  offers: any = [];
  fetchOffersFailed = false;
  studentCustomOffers: any = [];
  fetchStudentCustomOffersFailed = false;
  creditsProvisionsHistory = [];
  isPackPermis = false;
  isPackCode = false;
  isPackCodePremium = false;
  isHourOnly = false;
  hasHours = false;
  paymentsDone = false;

  cerfaStatus: any;
  noCerfa = true;
  isCerfaValid = false;
  cerfaDone = false;
  statsSent = false;

  studentHasValidCode = false;

  stepChangeSub: any;
  pageLoaderSteps = [
    'init0',
    'init1',
    'init2',
    'init3',
    'init4',
    'init5',
    'initPage',
  ];
  hasMadeInit = false;
  initPageDone = false; // for shimmers
  fnInitPageLaunched = false; // for controllers

  constructor(
    public pageLoaderService: PageLoaderService,
    public utils: UtilsService,
    public navigationService: NavigationService,
    public appInitService: AppInitService,
    public studentService: StudentService,
    private modalController: ModalController,
    private cerfaService: CerfaService,
    private statsService: StatsService,
    private paymentsService: PaymentsService,
    private router: Router,
    private offersService: OffersService
  ) {
    super({ cancel: false, subscription: null });

    this.checkPageLoadingTimeInterval = setInterval(() => {
      const now = Date.now();
      // 3 sec
      if (now - this.pageStart >= 3000) {
        this.longLoading = true;
        clearInterval(this.checkPageLoadingTimeInterval);
      }
    }, 200);

    if (!this.appInitService.done) {
      this.navigationService.timestamp = Date.now();
      this.navigationService.lastLink = this.router.url.substr(1);
      this.hasMadeInit = true;
    } else {
      this.hasMadeInit = false;
    }

    this.userLifeCycle = this.studentService.getUserLifeCycle(this.student); // if student not ready return guest
    if (this.appInitService.done) {
      this.pageLoaderSteps = ['initApp', 'initPage'];
      this.pageLoaderService.setSteps(
        this.pageLoaderSteps.indexOf('initApp') + 1,
        this.pageLoaderSteps.length
      );
    }
    this.stepChangeSub = this.appInitService.onStepChange().subscribe(state => {
      if (state?.init >= 3 && state?.stepDone && !this.fnInitPageLaunched) {
        this.fnInitPageLaunched = true;
        this.initPage();
      }
      if (state?.init && state?.stepDone) {
        this.pageLoaderService.setSteps(
          state.init + 1,
          this.pageLoaderSteps.length
        );
      }
      if (state?.initDone) {
        this.initPage();
      }
    });
  }

  ionViewWillLeave() {
    // this.cancel = true;
    if (!!this.subscription) {
      this.subscription.unsubscribe();
    }
    if (!!this.stepChangeSub) {
      this.stepChangeSub.unsubscribe();
    }
  }

  dateToFormatFr(input?: any) {
    // console.log('-------------------');
    // console.log('dateToFormatFr input', input, typeof input);
    let output = this.dateToMoment(); // today by default
    if (!!input) {
      output = this.dateToMoment(input);
      if (typeof input === 'string') {
        output = this.dateToMoment(input);
        // if (!input.includes('+')) {
        //   console.log('input string', input);
        // }
        if (input.includes('/')) {
          console.error('input string', input);
        }
        // console.log('output', output);
        // console.log('-------------------');
      } else if (typeof input === 'number') {
        // timestamp
        output = this.dateToMoment(input);
        // console.log('input timestamp', input);
        // console.log('output', output);
        // console.log('-------------------');
      } else if (typeof input === 'object') {
        if (
          !moment.isMoment(input) &&
          !!input.year &&
          !!input.month &&
          !!input.day
        ) {
          // custom object
          const year = input.year;
          const month =
            Number(input.month) < 10
              ? '0' + Number(input.month)
              : Number(input.month);
          const day = input.day < 10 ? '0' + input.day : input.day;
          const str = year + '-' + month + '-' + day + ' 00:00:00';
          output = this.dateToMoment(str);
          // console.log('input custom object', input, str);
          // console.log('output', output);
          // console.log('-------------------');
        } else {
          // date object
          output = this.dateToMoment(input);
          // console.log('input date', input, input.isValid());
          // console.log('output', output);
        }
      }
    }
    if (!output.isValid()) {
      console.log('-------------------');
      console.error('dateToFormatFr input', input, typeof input);
      console.error(
        'dateToFormatFr output',
        output,
        output.toString(),
        output.isValid()
      );
      console.error('-------------------');
    }
    // console.log('dateToFormatFr output', output, output.toString(), output.isValid());
    // console.log('-------------------');
    return output;
  }

  dateToMoment(input?: any) {
    const zone = 'Europe/Paris';
    moment.tz.setDefault(zone);
    moment.locale('fr');
    if (!!input) {
      return moment(input).tz(zone);
    }
    return moment().tz(zone);
  }

  async initPage() {
    const isSignedInHard = await this.studentService.isSignedInHard();
    if (!!isSignedInHard) {
      this.student = this.studentService.student;
      this.creditStocks = this.studentService.getCreditStocksAsOrderedArray();
      this.userLifeCycle = this.studentService.getUserLifeCycle(this.student); // if student not ready return guest
      this.getPayments();

      const resGetStudentCustomOffers = await this.offersService
        .fetchStudentCustomOffers(this.student, 'all')
        .toPromise();
      if (
        !!resGetStudentCustomOffers &&
        !!resGetStudentCustomOffers.errorCode &&
        resGetStudentCustomOffers.errorCode === 'E301'
      ) {
        this.fetchStudentCustomOffersFailed = true;
      } else {
        this.studentCustomOffers = resGetStudentCustomOffers;
      }

      this.fetchCerfa();
      this.creditsProvisionsHistory =
        this.paymentsService.creditsProvisionsHistory;
      // console.log('creditsProvisionsHistory', this.creditsProvisionsHistory);

      if (!!this.student.codePassedAt) {
        // DATE TO CHANGE
        const today = this.dateToFormatFr();
        // DATE TO CHANGE
        const codePassedAt = this.dateToFormatFr(this.student.codePassedAt);
        // DATE TO CHANGE
        const codeDateLimit = this.dateToFormatFr(
          new Date(
            codePassedAt.year() + 5,
            codePassedAt.month(),
            codePassedAt.date()
          )
        );

        this.studentHasValidCode = today < codeDateLimit ? true : false;
      }
    } else {
      this.paymentsDone = true;
      this.pageLoaderService.setSteps(
        this.pageLoaderSteps.indexOf('initPage') + 1,
        this.pageLoaderSteps.length
      );
      setTimeout(() => {
        this.pageLoaderService.stepsDone();
      }, 300);
    }
    // PAGE LOAD EVENT
    if (
      !!this.navigationService.timestamp &&
      !!this.navigationService.lastLink &&
      !this.statsSent
    ) {
      const statObj = {
        page: this.navigationService.lastLink,
        loadTime:
          this.dateToFormatFr().valueOf() - this.navigationService.timestamp,
        withInit: this.hasMadeInit,
      };
      if (this.statsService.isDebug) {
        console.log(statObj);
      }
      this.statsService.send({ name: 'page:view', payload: statObj });
      this.statsSent = true;
    }
  }

  fetchCerfa() {
    this.cerfaStatus = this.cerfaService.cerfa;
    // console.log('fetchCerfa', this.cerfaService.cerfa);
    if (!!this.cerfaStatus) {
      this.noCerfa = false; // j'ai recup un cerfa
      this.isCerfaValid =
        !!this.cerfaStatus.confirmed_at &&
        this.cerfaStatus.confirmed_at !== null
          ? true
          : false; // cerfa valid ou pas en fonction de la date de confirmation
    } else {
      this.noCerfa = true; // j'ai pas recup de cerfa
    }
    this.cerfaDone = true; // check cerfa done
    this.pageLoaderService.setSteps(
      this.pageLoaderSteps.indexOf('initPage') + 1,
      this.pageLoaderSteps.length
    );
    setTimeout(() => {
      this.pageLoaderService.stepsDone();
    }, 300);
  }

  getPayments() {
    this.studentPurshases = this.studentService.getStudentPurshases();

    const resGetOffers = this.studentPurshases.offers;
    if (
      !!resGetOffers &&
      !!resGetOffers.errorCode &&
      resGetOffers.errorCode === 'E301'
    ) {
      this.fetchOffersFailed = true;
    } else {
      this.offers = resGetOffers;
    }
    this.gifts = this.studentPurshases.gifts;
    this.studentPurshases.linkOfferTopayment();
    this.studentPurshases.removeCouponsIfPresentInPayments();
    this.payments = this.studentPurshases.payments;
    this.coupons = this.studentPurshases.coupons;
    this.cpfSubscriptions = this.studentPurshases.cpfSubscriptions;

    this.hasHours = this.studentPurshases.hasHours();
    this.isHourOnly = this.studentPurshases.isHourOnly();
    this.isPackCode = this.studentPurshases.isPackCode();
    this.isPackCodePremium = this.studentPurshases.isPackCodePremium();
    this.isPackPermis = this.studentPurshases.isPackPermis();

    // << REMOVE WHEN 1.52.0 IS MASSIVELY ADOPTED
    this.gifts = this.gifts.filter(elt => elt.description !== 'CPF-SUB');
    // << REMOVE WHEN 1.52.0 IS MASSIVELY ADOPTED

    const tmp = this.gifts.concat(this.coupons).concat(this.cpfSubscriptions);
    this.paymentsGiftsCoupons = tmp.concat(this.payments);

    // Remove payment from a payement-plan if they are not the first one, since it's now managed by the view
    let i = this.paymentsGiftsCoupons.length;
    while (i--) {
      if (
        this.paymentsGiftsCoupons[i].payment_plan_user_id &&
        this.paymentsGiftsCoupons[i].plan_position > 1
      ) {
        this.paymentsGiftsCoupons.splice(i, 1);
      }
    }

    this.paymentsDone = true;
  }

  async selectOffer(offerId) {
    if (!!offerId) {
      if (this.studentPurshases.anyPurshases()) {
        if (
          !this.student?.driving_department ||
          (!!this.student?.driving_department &&
            !this.student?.driving_department?.pricing_zone_id)
        ) {
          if (
            !!this.offers &&
            this.offers.length > 0 &&
            !this.fetchOffersFailed
          ) {
            const offerFound = this.offers.find(elt => elt.id === offerId);
            if (!!offerFound) {
              const offerFoundId = offerFound.id ? offerFound.id : null;
              // console.log('offferId custom', offerFoundId);
              const url = `tunnel-paiement/${offerFound.offer_credit_type}/${offerFound.offer_type}/${offerFound.min_quantity}`;
              this.openLink(url);
            }
          }
        } else {
          if (
            !!this.studentCustomOffers &&
            this.studentCustomOffers.length > 0 &&
            !this.fetchStudentCustomOffersFailed
          ) {
            const offerFound = this.studentCustomOffers.find(
              elt => elt.id === offerId
            );
            const offerFoundId =
              !!offerFound && !!offerFound.id ? offerFound.id : null;
            // console.log('offferId', offerFoundId);
            const url = `tunnel-paiement/${offerFound.offer_credit_type}/${offerFound.offer_type}/${offerFound.min_quantity}`;
            this.openLink(url);
          }
        }
      }
    } else {
      console.error('AchatsPage selectOffer : Offer not found !');
    }
  }

  toggleDetails(id) {
    const allDetailsElt = document.getElementsByClassName('expiration-details');
    if (allDetailsElt.length > 0) {
      for (let i = 0; i < allDetailsElt.length; i++) {
        if (allDetailsElt[i].id !== id) {
          allDetailsElt[i].classList.remove('show');
        }
      }
    }
    const detailsElt = document.getElementById(id);
    if (!!detailsElt) {
      detailsElt.classList.toggle('show');
    }
  }

  async openModalPack(
    bannerInfo?: any,
    type?: string,
    noClose = false,
    customClass = ''
  ) {
    // evs-global.scss : small-modal | medium-modal
    if (!type) {
      type = 'marketingRegular';
    }
    let props;
    if (!!bannerInfo) {
      props = {
        type: type,
        bannerInfo: {
          item_id: bannerInfo.itemId,
          item_promo_type: bannerInfo.itemPromoType,
          item_location_id: bannerInfo.itemLocationId,
          item_location_format: bannerInfo.itemLocationFormat,
          item_promo_content: bannerInfo.itemPromoContent,
        },
      };
    } else {
      props = {
        type: type,
        bannerInfo: null,
      };
    }
    let modal;
    if (noClose) {
      modal = await this.modalController.create({
        component: ModalMarketingComponent,
        backdropDismiss: false,
        cssClass: customClass,
        componentProps: props,
      });
    } else {
      modal = await this.modalController.create({
        component: ModalMarketingComponent,
        cssClass: customClass,
        componentProps: props,
      });
    }
    return await modal.present();
  }

  async openModalIframe(url: any, type?: string, noClose = true) {
    if (!type) {
      type = 'iframe';
    }
    let modal;
    if (noClose) {
      modal = await this.modalController.create({
        component: ModalIframeComponent,
        backdropDismiss: false,
        cssClass: 'custom-modal-iframe',
        componentProps: {
          type: type,
          url: url,
        },
      });
    } else {
      modal = await this.modalController.create({
        component: ModalIframeComponent,
        cssClass: 'custom-modal-iframe',
        componentProps: {
          type: type,
          url: url,
        },
      });
    }
    return await modal.present();
  }

  closeModals() {
    const modals = document.getElementsByTagName('ion-modal');
    while (modals.length > 0) {
      modals[0].parentNode.removeChild(modals[0]);
    }
  }

  async openLink(link, options?) {
    if (link === 'modalAchats') {
      this.openModalPack(null, link);
    } else if (link === 'exam-code-payment') {
      const examOffer = this.offers.filter(
        elt => elt.offer_type === 'code_exam'
      );
      if (examOffer.length > 0 && !!examOffer[0].id) {
        this.openLink('paiement', { paiementId: examOffer[0].id });
      } else {
        console.error('AchatsPage credit exam code : offer not found!');
      }
    } else if (link === 'exam-conduite-payment') {
      const examOffer = this.offers.filter(
        elt => elt.offer_type === 'driving_exam'
      );
      if (examOffer.length > 0 && !!examOffer[0].id) {
        this.openLink('paiement', { paiementId: examOffer[0].id });
      } else {
        console.error('AchatsPage credit exam conduite : offer not found!');
      }
    } else {
      const callbackUrl = await this.navigationService.open(link, options);
      if (!!callbackUrl && callbackUrl !== '') {
        this.openModalIframe(callbackUrl);
      }
    }
  }
}
